export default "__VITE_ASSET__Cef82H_Q__";